<template>
  <div>
    <el-dialog
      width="660px"
      center
      :title="title"
      :visible.sync="visible"
      @closed="onClose"
    >
      <div class="checkPersonList">
        <!-- ========== 新增：已选择著作权人展示区域 ========== -->
        <div class="selected-wrap" v-if="selectedList.length > 0">
          <div class="selected-title">已选择著作权人：</div>
          <div class="selected-tags">
            <el-tag
              closable
              v-for="item in selectedList"
              :key="item.uniqueCode"
              @close="handleRemoveSelect(item)"
            >
              {{ item.obligeeType == '1' ? item.userName : item.companyName }}
            </el-tag>
          </div>
        </div>

        <!-- 搜索框 -->
        <div class="searchWrap">
          <el-input
            v-model="searchKey"
            placeholder="请输入著作权人名称搜索"
            clearable
            prefix-icon="el-icon-search"
            size="small"
          />
        </div>

        <div>
          <el-table ref="table" :data="filteredOptions" border fit highlight-current-row style="width: 100%;">
            <el-table-column label="选择" width="55" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.checked"
                  @change="handleRowCheck(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="email" label="著作权人" align="center">
              <template slot-scope="scope">
                {{ scope.row.data.obligeeType=='1'?scope.row.data.userName:scope.row.data.companyName}}
              </template>
            </el-table-column>
            <el-table-column prop="email" label="证件号" align="center">
              <template slot-scope="scope">
                {{ scope.row.data.uniqueCode}}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container obligeeListPagination">
              <el-pagination background @size-change="obligeeListHandleSizeChange" @current-change="obligeeListHandleCurrentChange" :current-page="obligeeListQuery.pageNum" :page-sizes="[10,20,30, 50]" :page-size="obligeeListQuery.pageSize" layout="total, prev, pager, next" :total="obligeeListTotal" :pager-count="5">
              </el-pagination>
          </div>
        </div>


        <!-- <el-checkbox-group v-model="selectType">
          <el-checkbox
            v-for="item in filteredOptions"
            :key="item.index"
            :label="item.index"
          > {{ item.data.obligeeType=='1'?item.data.userName:item.data.companyName}}</el-checkbox>
        </el-checkbox-group> -->
        <div class="btnWrap">
          <el-button
            v-if="JSON.stringify(linkObj)!='{}'"
            type="text"
            @click="goto(linkObj.path)"
          >{{linkObj.label}}</el-button>
          <el-button type="primary" @click="onSubmit">确认添加</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'choosePersonDialog',
  props: {
    // 类型
    listOpt: {
      type: Array,
      required: true
    },
    // value: {
    //   type: [Number, String, Array],
    // },
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    linkObj: {
      type: Object,
      default: val => ({})
    }
  },
  data () {
    return {
      // 弹框是否显示
      visible: false,
      selectType: [],
      options: [],
      // 搜索关键词
      searchKey: '',
      selectedList: [], //全局已选中著作权对象，翻页不丢失
      obligeeListQuery: {
        pageNum: 1,
        pageSize: 10
      },
      obligeeListTotal: 0
    }
  },
  computed: {
    // 过滤后的选项，保留原始索引
    filteredOptions () {
      const key = (this.searchKey || '').trim().toLowerCase()
      // 先搜索过滤
      let allData = []
      if (!key) {
        allData = this.options.map((item, index) => ({
          data: item,
          index,
          checked: this.selectedList.some(s => s.uniqueCode === item.uniqueCode)
        }))
      } else {
        allData = this.options
          .map((item, index) => ({ data: item, index }))
          .filter(({ data }) => {
            const name = data.obligeeType == '1' ? data.userName : data.companyName
            return (name || '').toLowerCase().includes(key)
          })
          .map(row => ({
            ...row,
            checked: this.selectedList.some(s => s.uniqueCode === row.data.uniqueCode)
          }))
      }
      // ✅ 前端分页：计算切片
      // 更新总条数
      this.obligeeListTotal = allData.length
      const start = (this.obligeeListQuery.pageNum - 1) * this.obligeeListQuery.pageSize
      const end = start + this.obligeeListQuery.pageSize
      return allData.slice(start, end)
    },
  },
  watch: {
    // value: {
    //   handler (newVal, oldVal) {
    //     this.selectType = newVal;
    //   },
    //   immediate: true //第一次进来触发
    // },
    value: {
      handler (newVal) {
        if (this.visible && Array.isArray(newVal)) {
          this.selectedList = JSON.parse(JSON.stringify(newVal))
        }
      },
      immediate: true
    },
    listOpt: {
      handler(newVal) {
        this.options = _.cloneDeep(newVal);
      },
      deep: true
    },
    searchKey() {
      this.obligeeListQuery.pageNum = 1
    },
  },
  created () {
    this.visible = true
    this.init()
    // 弹窗打开回显外部传入选中数据
    if (Array.isArray(this.value)) {
      this.selectedList = JSON.parse(JSON.stringify(this.value))
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.options = _.cloneDeep(this.listOpt);
    })
  },
  methods: {
    init () {
      console.log("init choose..")
    },
    goto (path) {
      this.$router.push({
        path: path,
        query: {}
      });
    },

    // =========新增方法=========
    handleRowCheck(row) {
      const item = row.data
      const idx = this.selectedList.findIndex(s => s.uniqueCode === item.uniqueCode)
      if (row.checked) {
        if (idx === -1) this.selectedList.push(item)
      } else {
        if (idx > -1) this.selectedList.splice(idx, 1)
      }
    },
    handleRemoveSelect(item) {
      this.selectedList = this.selectedList.filter(s => s.uniqueCode !== item.uniqueCode)
    },
    // =========新增分页事件=========
    obligeeListHandleSizeChange(val) {
      this.obligeeListQuery.pageSize = val
      this.obligeeListQuery.pageNum = 1
    },
    obligeeListHandleCurrentChange(val) {
      this.obligeeListQuery.pageNum = val
    },

    onSubmit(){
      // 如果用户是‘M’，则只能选择一个著作权人
      const userInfo = localStorage.getItem('userInfo');
      const RegisterRedirect = this.$route.query.redirect;  // 渠道用户，进行全流程登记，M用户全流程登记，可以多选著作权人
      // console.log('RegisterRedirect:',RegisterRedirect);
      if (userInfo) {
        const userType = JSON.parse(userInfo).type;
        // console.log('userType-------:', userType);
        if(userType == 'M' && RegisterRedirect != 1){ // N为旧版本登记，M为新版本登记 
        // if(userType == 'N'){ // N为旧版本登记，M为新版本登记
          if(this.selectedList.length > 1){
            this.$message.error('只能选择一个著作权人!');
            return false
          }

          // 检查是否有电子签名/印章，没有的话，跳转到个人中心-著作权人管理里面 进行添加
          // let obligeeInfo = this.listOpt[this.selectType[0]]
          let obligeeInfo = this.selectedList[0]
          if(!obligeeInfo.supportingMaterial || obligeeInfo.supportingMaterial.signature == ''){ // 如果没有电子签名/印章
            this.$confirm('<p>该著作权人没有还上传电子签名/印章。</p><p>是否去添加?</p>', '提示', {
              dangerouslyUseHTMLString: true, // 允许使用 HTML
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              // 用户点击确定后的操作
              this.$router.push({path: '/Mine/Obligee',query: {uniqueCode: obligeeInfo.uniqueCode},}) // 使用路由跳转
            }).catch(() => {
              // 用户点击取消     
            })
            return false
          }

        }
        
      }
      // let arr=[];
      //   for (let i = 0; i < this.selectType.length; i++) {
      //     const element = this.selectType[i];
      //     arr.push(this.listOpt[element*1]);
      //   }
      //     this.$emit('input',arr);
      //     this.onClose()

      // 直接抛出选中数组，不再循环listOpt
      this.$emit('input', this.selectedList);
      this.onClose()
    },
    // 关闭弹框时触发的事件
    onClose () {
      this.selectedList = [] //关闭弹窗清空选中缓存
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>
.checkPersonList {
  .searchWrap {
    margin-bottom: 12px;
  }
  /* =========新增已选标签样式========= */
  .selected-wrap {
    margin-bottom:12px;
    .selected-title {
      font-size:13px;
      color:#666;
      margin-bottom:6px;
    }
    .selected-tags {
      display:flex;
      flex-wrap: wrap;
      gap:6px;
    }
  }
  .btnWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
  }
}
/deep/ .el-dialog {
  top: 50%;
  margin-top: 0 !important;
  transform: translateY(-50%);
}
/deep/ .el-table th,
/deep/ .el-table td {
  height: 40px; // th和td统一高度，按需改
  padding:0;
}
/deep/ .el-table th {
  background-color: #f5f7fa; //表头默认背景色
}
/deep/.el-pagination{
  padding: 2px 0;
  margin-top: 12px;
}
/deep/ .el-dialog--center .el-dialog__body{
    padding-top:0;
}
</style>
